import BaseCtrl from 'edge/platform/base/BaseCtrl';
import LocalDateUtil from 'edge/api/gw-portals-util-js/LocalDateUtil';
import BusinessConstant from 'customerEdge/policycommon/common/BusinessConstant';

const fn = ($scope, $filter, $timeout, LocaleService, InsuranceSuiteMetadata, StateUtils, submissionViewModel, ModalService) => {
    const ctrl = Object.create(BaseCtrl);
    const submissionVM = submissionViewModel();

    ctrl.init = () => {
        $scope.$filter = $filter;
        $scope.periodStartDate = submissionVM.baseData.periodStartDate.value;
        $scope.lobData = submissionVM.lobData.value;
        $scope.periodEndDate = submissionVM.baseData.periodEndDate.value;

        //UCWPRODENG-818
        const dateQuoteNeededDate = LocalDateUtil.toMidnightDate(submissionVM.baseData.dateQuoteNeeded_PSA.value);
        //UCWPRODENG-798
        // const dateQuoteNeededDate = LocalDateUtil.toMidnightDate(submissionVM.createTime.value);
        $scope.quoteExpirationDate = new Date(dateQuoteNeededDate);
        $scope.quoteExpirationDate.setDate(dateQuoteNeededDate.getDate() + BusinessConstant.QUOTE_EXPIRES_IN_DAYS);

        const chosenQuoteID = submissionVM.bindData.chosenQuote.value;
        $scope.chosenQuote = submissionVM.quoteData.offeredQuotes.value.find(item => item.publicID === chosenQuoteID);
        $scope.chosenOffering = submissionVM.lobData.puw_PSA.offerings.value.find(item => item.branchCode === $scope.chosenQuote.branchCode);
        if( $scope.chosenOffering.firstVehicleVirtualFlavour_PSA != undefined){
            $scope.firstVehicleVirtualFlavour_PSA = $scope.chosenOffering.firstVehicleVirtualFlavour_PSA.replace(/Certfied/g, "Certified");
        }
    };

    ctrl.next = function (callback) {
        const modalpromise = ModalService.showWarning(
            'psa.quoteandbind.policy-information.Do you want to buy now?', 'psa.quoteandbind.policy-information.Please verify all data is correct', '',
            'quoteandbind.pa.controllers.PAVehicleDetailsCtrl.Yes',
            'gw-btn-primary',
            $filter('translate')('psa.quoteandbind.policy-information.Cancel')
        ).result;
        modalpromise.then(() => {
            callback(submissionVM);
        }).catch(() => {
            callback();
        });
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$filter', '$timeout', 'LocaleService', 'InsuranceSuiteMetadata', 'StateUtils', 'submissionViewModel', 'ModalService'];

export default fn;
